
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Fourseaterbharat() {



    const cardData =
    {
        keyword: '45 Seater AC Bharat Benz On Rent Pune',
        heading: 'Amruta Travels: 45 Seater AC Bharat Benz On Rent Pune',
        headingDescription: 'Amruta Travels offers 45 Seater AC BharatBenz Bus on Rent in Pune, providing a premium travel solution for medium-to-large groups seeking luxury, space, and comfort. Whether it is a corporate retreat, school or college excursion, wedding transport, or an outstation group tour, our fully air-conditioned 45-seater BharatBenz buses are designed to deliver a safe and enjoyable experience.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',



"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Located around 120 km from Pune, Mahabaleshwar is a scenic hill station famous for its strawberry farms, lush valleys, and viewpoints like Arthur’s Seat and Wilson Point. It's an ideal spot for nature lovers and weekend getaways."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range are popular for their green valleys, monsoon waterfalls, and attractions like Bhushi Dam and Tiger’s Leap. Great for a quick escape from city life."
  },
  {
    "title": "Shirdi",
    "description": "About 190 km from Pune, Shirdi is a major pilgrimage town dedicated to Sai Baba. The Sai Baba Temple attracts millions of devotees annually. The spiritual atmosphere makes it perfect for religious tourism."
  },
  {
    "title": "Goa",
    "description": "Located nearly 450 km from Pune, Goa is the ultimate beach holiday destination. From vibrant nightlife and water sports to heritage forts and churches, Goa offers something for every traveler."
  },
  {
    "title": "Nashik",
    "description": "Around 210 km from Pune, Nashik is known for its religious significance and as India’s wine capital. Key attractions include the Kalaram Temple, Sula Vineyards, and Trimbakeshwar Temple."
  },
  {
    "title": "Alibaug",
    "description": "Situated 140 km away, Alibaug is a coastal town with serene beaches like Nagaon and historical forts such as Kolaba Fort. It’s a popular choice for beach lovers and family picnics."
  },
  {
    "title": "Kolhapur",
    "description": "Roughly 235 km from Pune, Kolhapur is home to the famous Mahalaxmi Temple and is known for its rich cultural heritage and spicy cuisine. It also offers attractions like Rankala Lake and Panhala Fort."
  },
  {
    "title": "Lavasa",
    "description": "Just 60 km from Pune, Lavasa is a planned city nestled in the Western Ghats, offering lakeside views, water sports, and a peaceful retreat. Perfect for a one-day outing or weekend stay."
  },
  {
    "title": "Satara & Kaas Plateau",
    "description": "About 120 km from Pune, Satara is a gateway to the Kaas Plateau, a UNESCO-listed biodiversity hotspot. Visit during the monsoon to witness a stunning bloom of wildflowers across the valley."
  },
  {
    "title": "Aurangabad",
    "description": "Situated 235 km from Pune, Aurangabad is known for the Ajanta and Ellora Caves (UNESCO World Heritage Sites), Bibi Ka Maqbara, and Daulatabad Fort. A must-visit for history and architecture enthusiasts."
  }
],

    "services": [
    {
      "name": "45 Seater AC Bharat Benz Hire",
      "description": "Amruta Travels offers 45-seater AC Bharat Benz buses for hire, perfect for large group travel. Whether it's for a corporate event, wedding, or group outing, our buses provide a comfortable and luxurious travel experience."
    },
    {
      "name": "Rent 45 Seater AC Bharat Benz in Pune",
      "description": "Rent a 45-seater AC Bharat Benz bus in Pune from Amruta Travels. Our buses are designed for comfort and efficiency, making them ideal for long-distance travel, corporate events, weddings, and more."
    },
    {
      "name": "45 Seater Bharat Benz Bus Rental Pune",
      "description": "Amruta Travels offers 45-seater Bharat Benz buses for rental in Pune. With spacious interiors, AC, and professional drivers, our buses are perfect for group travel, corporate events, and other special occasions."
    },
    {
      "name": "45 Seater Bharat Benz on Rent for Picnic",
      "description": "Plan your next group picnic with our 45-seater Bharat Benz buses. With ample space, air conditioning, and comfort, our buses provide a perfect travel solution for picnics and outings."
    },
    {
      "name": "45 Seater AC Bharat Benz for Corporate Event",
      "description": "For your next corporate event, rent a 45-seater AC Bharat Benz bus from Amruta Travels. Our buses offer a high level of comfort and professionalism, ensuring smooth and enjoyable transport for your team."
    },
    {
      "name": "45 Seater AC Bharat Benz for Wedding",
      "description": "Ensure smooth and luxurious transportation for your wedding guests with a 45-seater AC Bharat Benz bus. Amruta Travels offers premium buses designed for weddings, ensuring comfort and style for your big day."
    }
  ],
  "tableData": [
    ["45 Seater AC Bharat Benz Hire", "Rent 45 Seater AC Bharat Benz in Pune"],
    ["45 Seater Bharat Benz Bus Rental Pune", "45 Seater Bharat Benz on Rent for Picnic"],
    ["45 Seater AC Bharat Benz for Corporate Event", "45 Seater AC Bharat Benz for Wedding"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Luxurious 45 Seater AC Bharat Benz on Rent in Pune",
    "WhyChoosedescription": "Amruta Travels offers 45 Seater AC Bharat Benz buses for rent in Pune, providing an exceptional travel experience for large groups. Whether you're organizing a corporate event, wedding, or long-distance group trip, these buses offer premium comfort, performance, and style."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Outings, Weddings, and Group Tours",
    "WhyChoosedescription": "Our 45 Seater AC Bharat Benz buses are perfect for transporting large groups for corporate conferences, weddings, group holidays, or school trips. With spacious interiors, modern amenities, and luxurious features, these buses ensure that your entire group travels in comfort and style."
  },
  {
    "WhyChooseheading": "State-of-the-Art Comfort with Premium Features",
    "WhyChoosedescription": "The 45 Seater AC Bharat Benz buses come equipped with plush seating, powerful air conditioning, entertainment systems, individual charging ports, and ample luggage space. These features ensure a relaxing and enjoyable ride, even for extended journeys."
  },
  {
    "WhyChooseheading": "Affordable Luxury with Clear and Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers affordable and transparent pricing for 45 Seater AC Bharat Benz bus rentals in Pune. Our all-inclusive pricing covers fuel, tolls, driver charges, and taxes—no hidden fees, allowing you to enjoy premium travel at competitive rates."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Timely Travel",
    "WhyChoosedescription": "Our experienced, licensed drivers are trained to provide the safest and most efficient travel experience. They are well-versed in both city and outstation routes, ensuring that your group arrives at the destination on time and safely."
  },
  {
    "WhyChooseheading": "Ideal for Long-Distance Travel and Large Group Events",
    "WhyChoosedescription": "The 45 Seater AC Bharat Benz buses are ideal for long-distance journeys and large group travel. Whether it’s a family vacation, corporate retreat, or wedding transportation, your group can enjoy the ride in spacious and comfortable seating, with plenty of room for luggage."
  },
  {
    "WhyChooseheading": "Well-Maintained Fleet for Smooth and Safe Journeys",
    "WhyChoosedescription": "Our fleet of 45 Seater AC Bharat Benz buses is regularly maintained and thoroughly inspected to ensure safety and reliability. You can count on our buses for a smooth, comfortable, and hassle-free journey."
  },
  {
    "WhyChooseheading": "Easy Booking Process and 24/7 Customer Support",
    "WhyChoosedescription": "Booking a 45 Seater AC Bharat Benz bus with Amruta Travels is quick and easy. You can book online, via phone, or visit our office in person. Our 24/7 customer support team is always available to assist with any inquiries, special requests, or changes to your itinerary."
  }
]




























    }

const faqData = [
  {
    question: 'Can I rent a 45-seater AC Bharat Benz bus in Pune with Amruta Travels?',
    answer: 'Yes, Amruta Travels offers 45-seater AC Bharat Benz buses for rent in Pune. These buses are ideal for large groups, corporate events, school trips, family gatherings, and outstation tours.',
  },
  {
    question: 'What amenities are available in the 45-seater AC Bharat Benz bus?',
    answer: 'Our 45-seater AC Bharat Benz buses come equipped with luxury features such as spacious push-back seats, air conditioning, large windows for a scenic view, reading lights, ample luggage space, and a high-quality sound system for an enjoyable travel experience.',
  },
  {
    question: 'Is the 45-seater AC Bharat Benz available for both local and outstation trips?',
    answer: 'Yes, the 45-seater AC Bharat Benz bus is available for local travel within Pune and for outstation trips to popular destinations like Shirdi, Mahabaleshwar, Goa, Lonavala, and more.',
  },
  {
    question: 'Does the rental include a driver?',
    answer: 'Yes, every rental of our 45-seater AC Bharat Benz includes an experienced and licensed driver who ensures the safety and comfort of all passengers during the journey.',
  },
  {
    question: 'How much does it cost to rent a 45-seater AC Bharat Benz in Pune?',
    answer: 'The cost depends on factors like distance, duration, and the type of trip. Typically, prices for renting a 45-seater AC Bharat Benz start from ₹38–₹45 per km. For an exact quote, please contact us with your travel details.',
  },
  {
    question: 'Is the 45-seater AC Bharat Benz bus suitable for long-distance travel?',
    answer: 'Yes, the 45-seater AC Bharat Benz bus is built for long-distance journeys. With its superior comfort, air conditioning, and spacious interiors, it’s perfect for extended travel with large groups.',
  },
  {
    question: 'Are the 45-seater AC Bharat Benz buses sanitized before each trip?',
    answer: 'Yes, all our buses, including the 45-seater AC Bharat Benz, are thoroughly cleaned and sanitized before every trip to ensure safety, hygiene, and comfort for all passengers.',
  },
  {
    question: 'How can I book a 45-seater AC Bharat Benz bus in Pune?',
    answer: 'You can easily book the 45-seater AC Bharat Benz bus online through our website or by calling our customer service team. We offer seamless booking assistance and ensure your travel requirements are met.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Vinod Nair',
    role: 'Corporate Coordinator, Pune',
    text: 'We hired a 45-seater AC Bharat Benz bus for our annual company conference. The bus was very comfortable, the driver was professional, and the overall experience was fantastic. Highly recommend Amruta Travels!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Desai',
    role: 'Wedding Planner',
    text: 'Amruta Travels provided us with a 45-seater AC Bharat Benz for transporting wedding guests. The bus was clean, spacious, and well-maintained, making it perfect for our large group. Excellent service!',
    rating: 5,
  },
];




















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];





const acBharatBenz45SeaterSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "45 Seater AC Bharat Benz on Rent in Pune",
  "image": "https://bushireinpune.com/assets/images/45-seater-ac-bharat-benz.jpg", // Update with actual image URL
  "description": "Rent a 45-seater AC Bharat Benz bus in Pune for corporate events, weddings, picnics, and group travel. Comfortable, luxurious, and reliable bus rental services.",
  "provider": {
    "@type": "Organization",
    "name": "Amruta Travels",
    "url": "https://bushireinpune.com"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "13526"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "16000", // Adjust price based on service details
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/45-seater-ac-bharat-benz-on-rent-in-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | 45 Seater AC Bharat Benz on Rent in Pune | Luxury Bus for Corporate Events & Weddings</title>
  <meta 
    name="description" 
    content="Rent a 45-seater AC Bharat Benz in Pune for corporate events, weddings, picnics, and group travel. Premium bus rental with air-conditioning and luxurious seating." 
  />
  <script type="application/ld+json">
    {JSON.stringify(acBharatBenz45SeaterSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/18.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Fourseaterbharat;